import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/services/core/base/base.service';
import { Response } from 'src/services/classes/models/response.interface';

export interface OrderRejectionPayload {
  orderId: number;
  reason: string;
}

const routes = {
  allOrders: 'api/v1/restaurants/kitchen-bar/all-orders',
  completedOrders: 'api/v1/restaurants/kitchen-bar/completed-orders',
  singleOrder: 'api/v1/restaurants/kitchen-bar', // append ID
  acceptOrder: 'api/v1/restaurants/kitchen-bar/accept-order', //append ID
  readyOrder: 'api/v1/restaurants/kitchen-bar/ready-order', // append ID
  rejectOrder: 'api/v1/restaurants/kitchen-bar/reject-order',
};

@Injectable({
  providedIn: 'root',
})
export class OrdersService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  getAllOrders(): Observable<any> {
    return this.sendGet(this.baseUrl(routes.allOrders));
  }

  getCompletedOrders(
    page: number,
    size = 10
  ): Observable<Response> {
    return this.sendGet(
      this.baseUrl(`${routes.completedOrders}?page=${page}&size=${size}`)
    );
  }


  getOrderById(orderId: number): Observable<any> {
    return this.sendGet(this.baseUrl(`${routes.singleOrder}/${orderId}`));
  }

  acceptOrder(orderId: number): Observable<any> {
    return this.sendPut(this.baseUrl(`${routes.acceptOrder}/${orderId}`), {});
  }

  markOrderAsReady(orderId: number): Observable<any> {
    return this.sendPut(this.baseUrl(`${routes.readyOrder}/${orderId}`), {});
  }

  rejectOrder(payload: OrderRejectionPayload): Observable<any> {
    return this.sendPut(this.baseUrl(routes.rejectOrder), payload);
  }
}
